import { HTMLAttributes, useEffect, useState } from 'react'

interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  clickable?: boolean
}

const Logo = ({ clickable = false, className = '', ...props }: LogoProps) => {
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    // Check if dark mode is enabled
    const checkDarkMode = () => {
      const isDark = document.documentElement.classList.contains('dark')
      setIsDarkMode(isDark)
    }

    checkDarkMode()

    // Watch for changes to the dark class
    const observer = new MutationObserver(checkDarkMode)
    observer.observe(document.documentElement, { 
      attributes: true, 
      attributeFilter: ['class'] 
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div
      className={`flex items-center ${clickable ? 'cursor-pointer' : ''} ${className}`}
      {...props}
    >
      <img
        key={isDarkMode ? 'dark' : 'light'}
        src={isDarkMode ? '/overmatch-logo-full-white.png' : '/overmatch-logo-full-navy.png'}
        alt="Overmatch"
        className="h-full w-full object-contain"
        style={{ display: 'block' }}
      />
    </div>
  )
}

export default Logo
